const AffirmLogo = () => (
  <svg width="38" height="16" viewBox="0 0 38 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2073_14488)">
      <mask id="mask0_2073_14488" maskUnits="userSpaceOnUse" x="0" y="0" width="38" height="16">
        <path d="M37.9601 0.5H0V15.5H37.9601V0.5Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2073_14488)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.48886 14.2076C2.0194 14.2076 1.78024 13.9787 1.78024 13.6023C1.78024 12.9006 2.57036 12.6646 4.01152 12.5129C4.01152 13.448 3.37287 14.2076 2.48444 14.2076H2.48886ZM3.10891 8.94882C2.07875 8.94882 0.894459 9.42866 0.25138 9.93656L0.838653 11.1646C1.35418 10.6971 2.1877 10.2971 2.93973 10.2971C3.65455 10.2971 4.04961 10.5339 4.04961 11.0111C4.04961 11.3313 3.7883 11.4936 3.29404 11.5576C1.4463 11.7945 -0.00195312 12.2997 -0.00195312 13.7094C-0.00195312 14.8269 0.80145 15.5032 2.0566 15.5032C2.95301 15.5032 3.75022 15.0102 4.12933 14.3629V15.3278H5.79991V11.2848C5.79991 9.61814 4.63157 8.94531 3.1098 8.94531L3.10891 8.94882Z"
          fill="#0A1113"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.876 9.13033V15.3198H21.6635V12.3373C21.6635 10.9207 22.5298 10.504 23.133 10.504C23.4046 10.5019 23.6706 10.5798 23.8974 10.7277L24.2243 9.09173C23.9709 8.99133 23.6998 8.94269 23.4271 8.94875C22.5085 8.94875 21.931 9.35136 21.5501 10.1707V9.13033H19.876Z"
          fill="#0A1113"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.5083 8.94922C31.5632 8.94922 30.8563 9.50187 30.4887 10.0352C30.1477 9.3466 29.4258 8.94922 28.5577 8.94922C27.6135 8.94922 26.9589 9.46853 26.6568 10.0668V9.1308H24.9331V15.3203H26.7224V12.1334C26.7224 10.9931 27.3274 10.4413 27.8916 10.4413C28.4027 10.4413 28.8722 10.7685 28.8722 11.6133V15.3203H30.6579V12.1334C30.6579 10.9764 31.2478 10.4413 31.8387 10.4413C32.3117 10.4413 32.813 10.7817 32.813 11.601V15.3203H34.5987V11.0413C34.5987 9.65099 33.6536 8.94922 32.5118 8.94922"
          fill="#0A1113"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5259 9.13097H13.9067V8.50202C13.9067 7.68272 14.3788 7.44939 14.7854 7.44939C15.063 7.45298 15.3359 7.52055 15.5826 7.64676L16.1336 6.39851C16.1336 6.39851 15.5746 6.03711 14.5586 6.03711C13.4169 6.03711 12.1174 6.67483 12.1174 8.67571V9.13097H9.41137V8.50202C9.41137 7.68272 9.88261 7.44939 10.2901 7.44939C10.5681 7.44937 10.8419 7.51715 11.0873 7.64676L11.6382 6.39851C11.3096 6.20816 10.7808 6.03711 10.0642 6.03711C8.92242 6.03711 7.62297 6.67483 7.62297 8.67571V9.13097H6.58838V10.4959H7.62563V15.3204H9.41137V10.4959H12.121V15.3204H13.9067V10.4959H15.5259V9.13097Z"
          fill="#0A1113"
        />
        <path d="M18.3762 9.13086H16.5923V15.3177H18.3762V9.13086Z" fill="#0A1113" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.6577 8.07914H18.4054C19.4249 4.90458 22.8839 2.11423 26.9974 2.11423C32.0003 2.11423 36.3238 5.88616 36.3238 11.7581C36.3391 12.9634 36.1718 14.1641 35.8278 15.3204H37.5241L37.5409 15.2625C37.8267 14.1178 37.9677 12.9425 37.9607 11.7634C37.9607 5.21511 33.1421 0.501953 27.001 0.501953C22.177 0.501953 17.8774 3.81774 16.6586 8.0809L16.6577 8.07914Z"
          fill="#4A4AF4"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2073_14488">
        <rect width="38" height="15" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default AffirmLogo;
